<app-radio-group
	label="Rental equipment (Including Lease, Lease to Own)"
	[items]="checkboxOptions"
	[ngModel]="rentalEquipment"
	(ngModelChange)="setRentalEquipment($event)"
></app-radio-group>

@if (rentalEquipment === 'yes') {
	<app-text-area
		class="mt-4"
		[ngModel]="rentalEquipmentDescription"
		(debounce)="setRentalEquipmentDescription($event)"
		placeholder="Please list common rental items that include water heaters, furnaces, air conditioners, water softeners, propane tanks, or alarm systems. These typically transfer to the buyer unless paid out before closing."
	></app-text-area>
}
